import React from 'react';
import '../ces.scss';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

const InfoBox = ({ title, text }) => {
  return (
    <Col md={4} sm={12}>
      {text === '' ? <div className='ces-box-head'>{title}</div>
        :
        <><div className='ces-box-title'>{title}</div>
          <div className='ces-box-subText'>{text}</div> </>}
    </Col>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default InfoBox;
